import { keepPreviousData } from '@tanstack/react-query';

import { IntegrationsMetaResponse } from '@playq/services-adhawk-scheduler';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const corpIntegrationsMetaQueryKeys: unknown[] = ['corp', 'integrations', 'meta', 'query'];

export const useIntegrationsMetaQuery = (
  options?: IUseQueryOptionsExtended<IntegrationsMetaResponse | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(corpIntegrationsMetaQueryKeys, () => services2.integrationsService.retrieveMeta(), {
    placeholderData: keepPreviousData,
    ...options,
  });

  return {
    ...res,
    available: res.data?.available,
    postbacks: res.data?.postbacks,
  };
};
